// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__BCD1S","upload":"Small_upload__1n523","imageWrap":"Small_imageWrap__1DqGw","removeBtn":"Small_removeBtn__3iwPZ"};